import React, { Component } from 'react';
import classnames from 'classnames';
import TextField from 'Components/forms/text-field/TextField';
import Search from '../search/Search.jsx';
import SearchIcon from 'Components/icons/SearchIcon';
import ChevronDownIcon from 'Components/icons/ChevronDownIcon';
import {
    DualListSelectorPanel,
    DualListSelectorHeading,
    DualListSelectorActionBar,
    DualListSelectorList,
  } from 'Components/DualListSelector';
import LinkInlineButton from 'Components/Button/LinkInlineButton';
import OutsideClickHandler from 'Components/OutsideClickHandler';
import ColumnWidget from 'Components/ColumnWidget/';
import CloseIcon from 'Components/icons/CloseIcon';
import PlusIcon from 'Components/icons/PlusIcon';
import './DualMerchantDataListSelector.scss'
import 'Components/forms/forms.styles.js';
import { OptionBoxPopupFooter } from 'Components/OptionBoxPopup';

class DualMerchantDataListSelector extends Component {

    constructor(props) {
        super(props);

        const { availableMerchantNumbers, selectedMerchantNumbers } = this.props;
        this.state = {
            finalAvailableDataAccess: availableMerchantNumbers ? availableMerchantNumbers.map((chain) => {return {...chain}}) : [],
            availableMerchantNumbers: availableMerchantNumbers ? availableMerchantNumbers : [],
            selectedMerchantNumbers: selectedMerchantNumbers ? selectedMerchantNumbers : [],
            overallFilter: '',
            availableFilter: '',
            activeFilter: '',
            acquirerCode : JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode,
            reportName: this.props.reportName,
            isMreFilterPaneVisible: this.props.isMreFilterPaneVisible,
            totalChainPageSize: 10,
            availableChainCurrentPage: 0,
            totalAvailableChainPages: 0,
            totalActiveChainPages: 0,
            activeChainCurrentPage: 0,
            totalMerchantNumbersPageSize: 100,
            availableMerchNumActivePage: 0,
            activeMerchNumActivePage: 0,
            totalAvailableMerchNumPages: 0,
            totalActiveMerchNumPages: 0,
            isDropDownVisible: false,
            isCollapsed: false,
            dropDownMerchNumbers: [],
            dropDownActiveMerchNumbers: [],
            availableChainSelected: '',
            activeChainSelected: '',
            isActiveCollapsed: false,
            selectedMidCount: 0,
            translations: this.props.translations,
            isViewFilter: false,
            isFilterApplied: false,
            label: this.props.label,
            whiteLabelingFlag: this.props.whiteLabelingFlag,
        };

        this.handleOnSubmit = this.handleOnSubmit.bind(this);
        this.scrollToBottom = this.scrollToBottom.bind(this);
    }

    componentDidMount() {
        console.log("component mounted");
    }

    componentDidUpdate(prevProps) {
        // for edit rule
        if ((this.props.isEditRule !== prevProps.isEditRule) && this.props.isEditRule === true) {
            this.updateEditFilter(this.props.selectedMerchantNumbers, this.state.availableMerchantNumbers);
        }

        // for view rule
        if((this.props.isViewFilter !== prevProps.isViewFilter) && this.props.isViewFilter === true) {
            this.updateViewFilter(this.props.selectedMerchantNumbers);
        }

        // for clearing filter valyes
        if((this.props.isClearAllFilters !== prevProps.isClearAllFilters) && this.props.isClearAllFilters === true) {
            this.cancelChanges();
        }

        // if merchant number error
        if((this.props.isMerchantNumberError !== prevProps.isMerchantNumberError) && this.props.isMerchantNumberError === true) {
            if(this.props.updatedMerchantNumbers && this.props.updatedMerchantNumbers.length > 0) {
                console.log("testing rule created merchant number....");
                const finalAvailableDataAccess = this.props.updatedMerchantNumbers.map((chain) => { return {...chain}});
                this.setState({
                    finalAvailableDataAccess: finalAvailableDataAccess,
                }, () => this.cancelChanges());
            } else {
                this.cancelChanges();
            }
        }

    }

    componentWillUnmount() {
        console.log("componenet unmounted!");
        sessionStorage.removeItem("mreDataAccess");
        this.cancelChanges();
    }

    updateViewFilter = (selectedMerchants) => {
        this.setState({
            selectedMerchantNumbers: selectedMerchants,
            isViewFilter: true,
        });
    }

    updateEditFilter = (selectedMerchants, availableMerchantNumbers) => {
        let newAvailableMerchants = availableMerchantNumbers.map((chain) => {
            return {...chain}
        });
        selectedMerchants.forEach((selectedChain) => {
            let fieldToRemove = newAvailableMerchants.find((chain) => chain.key === selectedChain.key);
            if(fieldToRemove) {
                let fieldToRemoveMids = [...new Set(selectedChain.mids.map(mid => mid.key))];
                newAvailableMerchants = newAvailableMerchants.map((chain) => {
                    if(chain.key === fieldToRemove.key)
                        return {...chain, mids: chain.mids.filter((mid) => !fieldToRemoveMids.includes(mid.key)), isExpanded: false}
                    else 
                        return {...chain}
                });

                // clearing map value if selected chain doesnt have mids left
                newAvailableMerchants = newAvailableMerchants.filter((chain) => {
                    if((chain.key === fieldToRemove.key && chain.mids.length > 0) || (chain.key !== fieldToRemove.key)) {
                        return true;
                    } 
                });
            }
        });

        this.setState({
            selectedMerchantNumbers: selectedMerchants,
            availableMerchantNumbers: newAvailableMerchants
        });
    }

    setAvailableSearchFilter = (newText) => {
        this.setState({ availableFilter: newText, isMreFilterPaneVisible: true, availableChainCurrentPage: 0, 
            availableMerchNumActivePage: 0 });
    }

    setActiveSearchFilter = (newText) => {
        this.setState({ activeFilter: newText, isMreFilterPaneVisible: true, activeChainCurrentPage: 0, activeMerchNumActivePage: 0 });
    }

    setOverallSearchFilter = (newText) => {
        this.setState({ overallFilter: newText, isMreFilterPaneVisible: true, availableChainCurrentPage: 0, activeChainCurrentPage: 0, 
            availableMerchNumActivePage: 0, activeMerchNumActivePage: 0   });
    }

    getSortedList = (dataList) => {
        dataList.sort((columnA, columnB) => {
            return Number(columnA.displayOrder) - Number(columnB.displayOrder);
        })
        return dataList;
    }

    getOverallSearchFilteredData = (dataList, overallFilter) => {
        if(overallFilter !== '') {
            let filteredMerchantNumbers = dataList.filter((chain) => {
                if(chain.mids.length > 0) {
                    let mids = chain.mids.filter(mid => mid.key.toLowerCase().includes(overallFilter.toLowerCase()));
                    if(mids && mids.length > 0) {
                        chain.mids = mids;
                        return true;
                    }
                } 

                if(chain.groupName.toLowerCase().includes(overallFilter.toLowerCase())) {
                    return true;
                }
            });
            return filteredMerchantNumbers;
        } 
        return dataList;
    }

    getAvailableSearchFilteredData = (dataList, availableFilter) => {
        if(availableFilter !== '') {
            let filteredMerchantNumbers = dataList.filter((chain) => {
                if(chain.mids.length > 0) {
                    let mids = chain.mids.filter(mid => mid.key.toLowerCase().includes(availableFilter.toLowerCase()));
                    if(mids && mids.length > 0) {
                        chain.mids = mids;
                        return true;
                    }
                } 

                if(chain.groupName.toLowerCase().includes(availableFilter.toLowerCase())) {
                    return true;
                }
            });
            return filteredMerchantNumbers;
        }
        return dataList;
    }

    getActiveSearchFilteredData = (dataList, activeFilter) => {
        if(activeFilter !== '') {
            let filteredMerchantNumbers = dataList.filter((chain) => {
                if(chain.mids.length > 0) {
                    let mids = chain.mids.filter(mid => mid.key.toLowerCase().includes(activeFilter.toLowerCase()));
                    if(mids && mids.length > 0) {
                        chain.mids = mids;
                        return true;
                    }
                } 

                if(chain.groupName.toLowerCase().includes(activeFilter.toLowerCase())) {
                    return true;
                }
            });
            return filteredMerchantNumbers;
        }
        return dataList;
    }

    addNewChain = (dataList, identifier, isChainLevel) => {
        if(identifier.isRuleCreated === 'false') {
            if(identifier.mids && identifier.mids.length > 0) {
                let newMids = identifier.mids.filter((mid) => mid.isRuleCreated === 'false');
                if(newMids && newMids.length > 0) {
                    dataList.push({...identifier, mids: newMids, isExpanded: !isChainLevel});
                }
            } else {
                dataList.push(identifier);
            }
        }
        return dataList;
    }

    updateExistingField = (dataList, identifier, isChainLevel) => {
        dataList = dataList.map((chain) => {
            if(chain.key === identifier.key) {
                // update mids
                let newMids = identifier.mids.filter((mid) => mid.isRuleCreated === 'false');
                return { ...chain, mids: chain.mids.concat(newMids), isExpanded: !isChainLevel};
            } else {
                return { ...chain };
            }
        });
        return dataList;
    }

    removeExistingField = (dataList, identifier, isChainLevel) => {
        let newDataList = dataList.filter((chain) => {
            if(chain.key === identifier.key && chain.isRuleCreated === 'false') {
                // remove mids if exists
                let mids = chain.mids.filter((mid) => !identifier.mids.includes(mid) || mid.isRuleCreated === 'true');
                if(mids && mids.length > 0) {
                    chain.mids = mids;
                    chain.isExpanded = !isChainLevel;
                    return true;
                }
                return false;
            } else {
                return true;
            }
        });
        return newDataList;

    }

    removeField = (identifier)  => {
        const { availableMerchantNumbers, selectedMerchantNumbers, overallFilter, activeFilter } = this.state;
        let existingChain = null;
        let filteredAvailMerchantNumbers = availableMerchantNumbers.map((chain) => { return {...chain} });
        let filtererdActiveMerchantNumbers = selectedMerchantNumbers.map((chain) => { return {...chain} });
        let newActiveMerchants = [];
        let newAvailableMerchants = [];

        if(filtererdActiveMerchantNumbers && filtererdActiveMerchantNumbers.length > 0) {
            filtererdActiveMerchantNumbers = this.getOverallSearchFilteredData(filtererdActiveMerchantNumbers, overallFilter);
            filtererdActiveMerchantNumbers = this.getActiveSearchFilteredData(filtererdActiveMerchantNumbers, activeFilter);
        }

        if(identifier.isChainLevel) {
            existingChain = this.checkIfKeyExists(filteredAvailMerchantNumbers, identifier.key);

            if(existingChain !== null) {
                // update available merchants
                newAvailableMerchants = this.updateExistingField(filteredAvailMerchantNumbers, identifier, identifier.isChainLevel);
            } else {
                // add new chain to available merchants
                newAvailableMerchants = this.addNewChain(filteredAvailMerchantNumbers, identifier, identifier.isChainLevel);
            }

            // removing chain from selected merchant numbers
            newActiveMerchants = this.removeExistingField(selectedMerchantNumbers, identifier, identifier.isChainLevel);

        } else {
            existingChain = this.checkIfKeyExists(filteredAvailMerchantNumbers, identifier.chain);

            let fieldToMove = filtererdActiveMerchantNumbers.filter((chain) => {
                if(chain.key === identifier.chain) {
                    chain.mids = chain.mids.filter((mid) => mid.key === identifier.key);
                    return true;
                }
            });

            if(fieldToMove) {
                fieldToMove.forEach((field) => {
                    if(existingChain !== null) {
                        // update available merchants
                        newAvailableMerchants = this.updateExistingField(filteredAvailMerchantNumbers, field, identifier.isChainLevel);
                    } else {
                        // add new chain to available merchants
                        newAvailableMerchants = this.addNewChain(filteredAvailMerchantNumbers, field, identifier.isChainLevel);
                    }

                    // removing chain from selected merchant numbers
                    newActiveMerchants = this.removeExistingField(selectedMerchantNumbers, field, identifier.isChainLevel);
                });
            }

        }

        this.setState({
            availableMerchantNumbers: newAvailableMerchants,
            selectedMerchantNumbers: newActiveMerchants,
        });
    };

    addField = (identifier) => {
        const { availableMerchantNumbers, selectedMerchantNumbers, overallFilter, availableFilter } = this.state;
        let existingChain = null;
        let filteredMerchantNumbers = availableMerchantNumbers.map((chain) => { return {...chain} });
        let filteredActiveMerchantNumbers = selectedMerchantNumbers.map((chain) => { return {...chain} });
        let newActiveMerchants = [];
        let newAvailableMerchants = [];

        if(filteredMerchantNumbers && filteredMerchantNumbers.length > 0) {
            filteredMerchantNumbers = this.getOverallSearchFilteredData(filteredMerchantNumbers, overallFilter);
            filteredMerchantNumbers = this.getAvailableSearchFilteredData(filteredMerchantNumbers, availableFilter);
        }

        if(identifier.isChainLevel) {
            existingChain = this.checkIfKeyExists(filteredActiveMerchantNumbers, identifier.key);

            if(existingChain !== null) {
                // updating selected merchant list
                newActiveMerchants = this.updateExistingField(filteredActiveMerchantNumbers, identifier, identifier.isChainLevel);
            } else {
                // adding new chain to selected merchant list
                newActiveMerchants = this.addNewChain(filteredActiveMerchantNumbers, identifier, identifier.isChainLevel);
            }

            // removing merchant list from available
            newAvailableMerchants = this.removeExistingField(availableMerchantNumbers, identifier, identifier.isChainLevel);
        } else {
            existingChain = this.checkIfKeyExists(filteredActiveMerchantNumbers, identifier.chain);

            let fieldToMove = filteredMerchantNumbers.filter((chain) => {
                if(chain.key === identifier.chain) {
                    chain.mids = chain.mids.filter((mid) => mid.key === identifier.key);
                    return true;
                }
            });

            if(fieldToMove) {
                fieldToMove.forEach((field) => {
                    if(existingChain !== null) {
                        // updaing selected merchant list
                        newActiveMerchants = this.updateExistingField(filteredActiveMerchantNumbers, field, identifier.isChainLevel);
                    } else {
                        // adding new chain to selected merchant list
                        newActiveMerchants = this.addNewChain(filteredActiveMerchantNumbers, field, identifier.isChainLevel);
                    }

                    // removing merchant list from available
                    newAvailableMerchants = this.removeExistingField(availableMerchantNumbers, field, identifier.isChainLevel);
                });
            }
        }

        this.setState({
            availableMerchantNumbers: newAvailableMerchants,
            selectedMerchantNumbers: newActiveMerchants,
        });
    }

    checkIfKeyExists = (dataList, key) => {
        let field = null;
        for(let index = 0; index < dataList.length > 0; index++) {
            if(dataList[index].key === key) {
                field = {...dataList[index]};
                break;
            }
        }
        return field;
    }

    addAllData = () => {
        const { availableMerchantNumbers, selectedMerchantNumbers, availableFilter, overallFilter } = this.state;
        let availableFilteredMerchants = availableMerchantNumbers.map(chain => { return {...chain}});
        let noFilteredAvailMerchants = availableMerchantNumbers.map(chain => { return {...chain}}); 
        let activeFilteredMerchants = selectedMerchantNumbers.map(chain => { return {...chain}});
        let existingChain = null;

        let newAvailableMerchants = [];
        let newActiveMerchants = [];

        if(availableFilteredMerchants && availableFilteredMerchants.length > 0) {
            availableFilteredMerchants = this.getOverallSearchFilteredData(availableFilteredMerchants, overallFilter);
            availableFilteredMerchants = this.getAvailableSearchFilteredData(availableFilteredMerchants, availableFilter);
        }

        if(availableFilteredMerchants && availableFilteredMerchants.length > 0) {
            availableFilteredMerchants.forEach((identifier) => {
                if(identifier.isChainLevel) {
                    existingChain = this.checkIfKeyExists(activeFilteredMerchants, identifier.key);
    
                    if(existingChain !== null) {
                        // updating selected merchant list
                        newActiveMerchants = this.updateExistingField(activeFilteredMerchants, identifier, identifier.isChainLevel);
                    } else {
                        // adding new chain to selected merchant list
                        newActiveMerchants = this.addNewChain(activeFilteredMerchants, identifier, identifier.isChainLevel);
                    }
    
                    // removing merchant list from available
                    newAvailableMerchants = this.removeExistingField(noFilteredAvailMerchants, identifier, identifier.isChainLevel);
    
                    if(newActiveMerchants)
                        activeFilteredMerchants = newActiveMerchants.map(chain => { return {...chain}});
    
                    if(newAvailableMerchants)
                        noFilteredAvailMerchants = newAvailableMerchants.map(chain => { return {...chain}});
                }
            });
    
            this.setState({
                availableMerchantNumbers: newAvailableMerchants,
                selectedMerchantNumbers: newActiveMerchants,
                availableMerchNumActivePage: 0,
                availableChainCurrentPage: 0,
            });
        }

    }

    removeAllData = () => {
        const { availableMerchantNumbers, selectedMerchantNumbers, activeFilter, overallFilter } = this.state;
        let activeFilteredMerchants = selectedMerchantNumbers.map((chain) => {return {...chain}});
        let activeNonFilteredMerchants = selectedMerchantNumbers.map((chain) => {return {...chain}});
        let availableFilteredMerchants = availableMerchantNumbers.map((chain) => {return {...chain}});
        let existingChain = null;
        let newAvailableMerchants = [];
        let newActiveMerchants = [];

        if(activeFilteredMerchants && activeFilteredMerchants.length > 0) {
            activeFilteredMerchants = this.getOverallSearchFilteredData(activeFilteredMerchants, overallFilter);
            activeFilteredMerchants = this.getAvailableSearchFilteredData(activeFilteredMerchants, activeFilter);
        }

        if(activeFilteredMerchants && activeFilteredMerchants.length > 0) {
            activeFilteredMerchants.forEach((identifier) => {
                if(identifier.isChainLevel) {
                    existingChain = this.checkIfKeyExists(availableFilteredMerchants, identifier.key);
    
                    if(existingChain !== null) {
                        // update available merchants
                        newAvailableMerchants = this.updateExistingField(availableFilteredMerchants, identifier, identifier.isChainLevel);
                    } else {
                        // add new chain to available merchants
                        newAvailableMerchants = this.addNewChain(availableFilteredMerchants, identifier, identifier.isChainLevel);
                    }
    
                    // removing chain from selected merchant numbers
                    newActiveMerchants = this.removeExistingField(activeNonFilteredMerchants, identifier, identifier.isChainLevel);
    
                    if(newActiveMerchants)
                        activeNonFilteredMerchants = newActiveMerchants.map(chain => { return {...chain}});
    
                    if(newAvailableMerchants)
                        availableFilteredMerchants = newAvailableMerchants.map(chain => { return {...chain}});
    
                }
            });
    
    
    
            this.setState({
                availableMerchantNumbers: newAvailableMerchants,
                selectedMerchantNumbers: newActiveMerchants,
                activeMerchNumActivePage: 0,
                activeChainCurrentPage: 0,
            });
        }
    };

    handleOnSubmit() {
        this.props.handleOnApplyActiveColumns(
          formatSavedColumns(this.state.availableColumns),
          formatSavedColumns(this.state.activeColumns),
        );

    }

    scrollToBottom() {
        this.activeColumnsListWrapperRef.scrollTop = this.activeColumnsListWrapperRef.scrollHeight;
    }

    onClick = () => {
        this.setState({
            isDropDownVisible: true,
            isFilterApplied: false,
        });
    }

    updateVisibleColumns = () => {
    }

    handleOutsideClick = (isFilterApplied) => {
        if(isFilterApplied || this.state.isFilterApplied) {
            this.setState({
                isDropDownVisible: false,
                isFilterApplied: true,
            },() => this.updateEditFilter(this.state.selectedMerchantNumbers, this.state.finalAvailableDataAccess));
        } else if(this.state.isDropDownVisible && !this.state.isFilterApplied) {
            this.setState({
                overallFilter: '',
                availableFilter: '',
                activeFilter: '',
                availableChainCurrentPage: 0,
                activeChainCurrentPage: 0,
                availableMerchNumActivePage: 0,
                activeMerchNumActivePage: 0,
                isDropDownVisible: false,
                isCollapsed: false,
                dropDownMerchNumbers: [],
                dropDownActiveMerchNumbers: [],
                availableChainSelected: '',
                activeChainSelected: '',
                isActiveCollapsed: false,
                isFilterApplied: false,
            }, () => this.updateEditFilter(this.props.selectedMerchantNumbers, this.state.finalAvailableDataAccess));
        }
    }

    disableAddAllAction = () => {
       return !(this.state.availableMerchantNumbers.length > 0);
    }

    disableRemoveAllAction = () => {
        return !(this.state.selectedMerchantNumbers.length > 0);
    }

    scrollChainAvailableTop = () => {
        const divElement = document.getElementById("available_chain");
        divElement.scrollIntoView({ behavior: 'smooth', block: 'nearest'});
    }

    scrollChainActiveTop = () => {
        const divElement = document.getElementById("active_chain");
        divElement.scrollIntoView({ behavior: 'smooth', block: 'nearest'});
    }

    scrollMidAvailableTop = () => {
        const divElement = document.getElementById("available_mid");
        divElement.scrollIntoView({ behavior: 'smooth', block: 'nearest'});
    }

    scrollMidActiveTop = () => {
        const divElement = document.getElementById("active_mid");
        divElement.scrollIntoView({ behavior: 'smooth', block: 'nearest'});
    }

    nextPageChainLevel = (event) => {
        let value = event.target.getAttribute('value');
        if(value === 'available') {
            if(this.state.acquirerCode === 'GPN') {
                this.setState((prevState) => ({
                    availableMerchNumActivePage: prevState.availableMerchNumActivePage + 1
                }), () => this.scrollChainAvailableTop());
            } else {
                this.setState((prevState) => ({
                    availableChainCurrentPage: prevState.availableChainCurrentPage + 1
                }), () => this.scrollChainAvailableTop());
            }
        } else {
            if(this.state.acquirerCode === 'HPY') {
                this.setState((prevState) => ({
                    activeChainCurrentPage: prevState.activeChainCurrentPage + 1
                }), () => this.scrollChainActiveTop());
            } else {
                this.setState((prevState) => ({
                    activeMerchNumActivePage: prevState.activeMerchNumActivePage + 1
                }), () => this.scrollChainActiveTop());
            }
        }
    }

    nextPageMidLevel = (event) => {
        let value = event.target.getAttribute('value');
        if(value === 'available') {
            this.setState((prevState) => ({
                availableMerchNumActivePage: prevState.availableMerchNumActivePage + 1
            }), () => this.scrollMidAvailableTop());
        } else {
            this.setState((prevState) => ({
                activeMerchNumActivePage: prevState.activeMerchNumActivePage + 1
            }), () => this.scrollMidActiveTop());
        }
    }

    previousPageChainLevel = (event) => {
        let value = event.target.getAttribute('value');
        if(value === 'available') {
            if(this.state.acquirerCode === 'GPN') {
                this.setState((prevState) => ({
                    availableMerchNumActivePage: prevState.availableMerchNumActivePage - 1
                }))
            } else {
                this.setState((prevState) => ({
                    availableChainCurrentPage: prevState.availableChainCurrentPage - 1
                }));
            }
        } else {
            if(this.state.acquirerCode === 'GPN') {
                this.setState((prevState) => ({
                    activeMerchNumActivePage: prevState.activeMerchNumActivePage - 1
                }))
            } else {
                this.setState((prevState) => ({
                    activeChainCurrentPage: prevState.activeChainCurrentPage - 1
                }));
            }
        }
    }

    previousPageMidLevel = (event) => {
        let value = event.target.getAttribute('value');
        if(value === 'available') {
            this.setState((prevState) => ({
                availableMerchNumActivePage: prevState.availableMerchNumActivePage - 1
            }));
        } else {
            this.setState((prevState) => ({
                activeMerchNumActivePage: prevState.activeMerchNumActivePage - 1
            }));
        }
    }

    openAvailableDropDownList = (identifier) => {
        // what for those which are only chains?
        const { availableMerchantNumbers } = this.state;
        let newAvailableMerchantNumbers = availableMerchantNumbers.map((chain) => {
            if(chain.key === identifier.key) {
                chain.isExpanded = !chain.isExpanded;
            } else {
                chain.isExpanded = false;
            }
            return chain;
        });

        let chainList = newAvailableMerchantNumbers.filter(chain => chain.key === identifier.key && chain.isExpanded === true);
        let merchantNumbers = [];
        chainList.forEach((chain) => {
            if(chain.key === identifier.key) {
                merchantNumbers = chain.mids;
            }
        });
        let totalPages = 0;
        if(merchantNumbers && merchantNumbers.length > 0) {
                let totalAvailableLength = merchantNumbers.length;
                let totalSize = this.state.totalMerchantNumbersPageSize;
                if(totalAvailableLength % totalSize > 0) {
                    totalPages = (Math.floor(totalAvailableLength / totalSize)) + 1;
                } else {
                    totalPages = totalAvailableLength / totalSize;
                }
            this.setState({
                dropDownMerchNumbers: merchantNumbers,
                isCollapsed: true,
                availableMerchNumActivePage: 0,
                totalAvailableMerchNumPages: totalPages,
                availableMerchantNumbers: [...this.state.availableMerchantNumbers],
                availableChainSelected: identifier.key,
            });
        } else {
            this.setState({
                dropDownMerchNumbers: [],
                isCollapsed: false,
                availableMerchNumActivePage: 0,
                availableChainSelected: '',
            });
        }
    }

    openActiveDropDownList = (identifier) => {
        const { selectedMerchantNumbers } = this.state;
        let newSelectedMerchantNumbers = selectedMerchantNumbers.map((chain) => {
            if(chain.key === identifier.key) {
                chain.isExpanded = !chain.isExpanded;
            } else {
                chain.isExpanded = false;
            }
            return chain;
        });

        let chainList = newSelectedMerchantNumbers.filter(chain => chain.key === identifier.key && chain.isExpanded === true);
        let merchantNumbers = [];
        chainList.forEach((chain) => {
            if(chain.key === identifier.key) {
                merchantNumbers = chain.mids;
            }
        });

        let totalPages = 0;
        if(merchantNumbers && merchantNumbers.length > 0) {
                let totalAvailableLength = merchantNumbers.length;
                let totalSize = this.state.totalMerchantNumbersPageSize;
                if(totalAvailableLength % totalSize > 0) {
                    totalPages = (Math.floor(totalAvailableLength / totalSize)) + 1;
                } else {
                    totalPages = totalAvailableLength / totalSize;
                }
            this.setState({
                dropDownActiveMerchNumbers: merchantNumbers,
                isActiveCollapsed: true,
                availableMerchNumActivePage: 0,
                totalActiveMerchNumPages: totalPages,
                selectedMerchantNumbers: [...this.state.selectedMerchantNumbers],
                activeChainSelected: identifier.key,
            });
        } else {
            this.setState({
                dropDownActiveMerchNumbers: [],
                isActiveCollapsed: false,
                availableMerchNumActivePage: 0,
                activeChainSelected: '',
                totalActiveMerchNumPages: 0,
                selectedMerchantNumbers: [...this.state.selectedMerchantNumbers],
            });
        }
    }

    showAvailableMerchantNumbers = () => {
        const { availableFilter, availableMerchantNumbers, overallFilter, availableMerchNumActivePage, 
            availableChainCurrentPage, acquirerCode, translations, 
            totalMerchantNumbersPageSize, totalChainPageSize } = this.state;
        let newAvailableMerchantNumbers = [];

        const extraActions = [
            {
              callback: this.addField,
              icon: PlusIcon,
            },
        ];

        const dropDownActions = [
            {
                callback: this.openAvailableDropDownList,
                icon: ChevronDownIcon,
            }
        ];


        if(acquirerCode === 'GPN') {
            let totalPages = 1;
            newAvailableMerchantNumbers = availableMerchantNumbers.map((chain) => {
                let newMerchantNumbers = [];
                if(chain.mids && chain.mids.length > 0) {
                    newMerchantNumbers = chain.mids;
                }

                if(overallFilter !== '') {
                    newMerchantNumbers = chain.mids.filter((mid) => mid?.key.toLowerCase().includes(overallFilter.toLowerCase()))
                }

                if(availableFilter !== '') {
                    newMerchantNumbers = chain.mids.filter((mid) => mid?.key.toLowerCase().includes(availableFilter.toLowerCase()));
                }

                if(newMerchantNumbers && newMerchantNumbers.length > 0) {
                    totalPages = Math.ceil(newMerchantNumbers.length / totalMerchantNumbersPageSize);
                }
                // sorting merchant numbers 
                newMerchantNumbers = this.getSortedList(newMerchantNumbers);

                return newMerchantNumbers.slice(availableMerchNumActivePage*totalMerchantNumbersPageSize, 
                    (availableMerchNumActivePage*totalMerchantNumbersPageSize)+totalMerchantNumbersPageSize).map((merchNum) => {
                    return (
                        <ColumnWidget
                            actions={extraActions}
                            desc={merchNum.key}
                            identifier={merchNum}
                            //isHidden={column.isHidden}
                            isReadOnly={merchNum.isRuleCreated === "false" ? false : true}
                            isSelected={false}
                            key={`${merchNum.key}_${availableMerchNumActivePage}`}
                            name={merchNum.key}
                            // toggleVisibility={this.toggleVisibility}
                            animate={false}
                            //id={`${this.props.id}_ColumnWidget`}
                            hideToolTip={false}
                            reportName={'MRE'}
                            extraClass={'column-widget__MRE'}
                        />
                    );
                });

            });
            return (
                <DualListSelectorList id='available_chain' extraClass={'dual-list-selector__list-chain_width'}>
                    {availableMerchNumActivePage === 0 && <div id='available_chain' className='dual-list-selector-pagination'>{translations.merchantNumbers}<span className='dual-list-selector-pagination__firstMidSpan'>{translations.page} {availableMerchNumActivePage + 1} {translations.of} {totalPages}</span></div>}
                    {availableMerchNumActivePage > 0 && <div id='available_chain' className='dual-list-selector-pagination'>{translations.merchantNumbers}<span className='dual-list-selector-pagination__prevMidSpan' value='available' onClick={(event) => this.previousPageChainLevel(event)}>{`<<  `}</span><span>{translations.page} {availableMerchNumActivePage + 1} {translations.of} {totalPages}</span></div>}
                    {newAvailableMerchantNumbers}
                    {availableMerchNumActivePage + 1 < totalPages && <div className='dual-list-selector-pagination'><span className='dual-list-selector-pagination__nextMidSpan' value='available' onClick={(event) => this.nextPageChainLevel(event)}>{availableMerchNumActivePage + 1 < totalPages ? `${translations.next} >>` : ''}</span></div>}
                </DualListSelectorList>
            );
        } else {
            let totalPages = 1;
            newAvailableMerchantNumbers = availableMerchantNumbers.map((chain) => {return {...chain}});

            newAvailableMerchantNumbers = this.getOverallSearchFilteredData(newAvailableMerchantNumbers, overallFilter);
            newAvailableMerchantNumbers = this.getAvailableSearchFilteredData(newAvailableMerchantNumbers, availableFilter);

            if(newAvailableMerchantNumbers && newAvailableMerchantNumbers.length > 0) {
                totalPages = Math.ceil(newAvailableMerchantNumbers.length / totalChainPageSize);
            }

            // sorting chain
            newAvailableMerchantNumbers = this.getSortedList(newAvailableMerchantNumbers);

            newAvailableMerchantNumbers = newAvailableMerchantNumbers.slice(availableChainCurrentPage*totalChainPageSize, 
                (availableChainCurrentPage*totalChainPageSize) + totalChainPageSize)
            .map((chain) => {
                if(!chain.isExpanded) {
                    return (
                        <ColumnWidget
                            actions={extraActions}
                            desc={chain.key}
                            identifier={chain}
                            //isHidden={column.isHidden}
                            isReadOnly={chain.isRuleCreated === "false" ? false : true}
                            isSelected={false}
                            key={`${chain.key}_${availableChainCurrentPage}`}
                            name={chain.key === "NA" ? `${translations.merchantNumbers}` : chain.key + ` - ${translations.chain}`}
                            // toggleVisibility={this.toggleVisibility}
                            animate={false}
                            //id={`${this.props.id}_ColumnWidget`}
                            hideToolTip={false}
                            isExpanded={chain.isExpanded}
                            dropdown={chain.mids.length > 0 ? dropDownActions : null}
                            reportName={'MRE'}
                            extraClass={'column-widget__MRE'}
                        />
                    );
                } else {
                    let totalPages = 1;
                    if(chain.mids && chain.mids.length > 0) {
                        totalPages = Math.ceil(chain.mids.length / totalMerchantNumbersPageSize);
                    }
                    let slicedMids = chain.mids.slice(availableMerchNumActivePage * totalMerchantNumbersPageSize, 
                        (availableMerchNumActivePage * totalMerchantNumbersPageSize) + totalMerchantNumbersPageSize);

                    // sorting mids
                    slicedMids = this.getSortedList(slicedMids);
                    return (
                        <div>
                    <ColumnWidget
                        actions={extraActions}
                        desc={chain.key}
                        //extraClass={column.extraClass}
                        identifier={chain}
                        //isHidden={column.isHidden}
                        isReadOnly={chain.isRuleCreated === "false" ? false : true}
                        isSelected={false}
                        key={`${chain.key}_${availableChainCurrentPage}`}
                        name={chain.key === "NA" ? `${translations.merchantNumbers}` : chain.key + ` - ${translations.chain}`}
                        // toggleVisibility={this.toggleVisibility}
                        animate={false}
                        //id={`${this.props.id}_ColumnWidget`}
                        hideToolTip={false}
                        isExpanded={chain.isExpanded}
                        dropdown={dropDownActions}
                        reportName={'MRE'}
                        extraClass={'column-widget__MRE'}
                    >
                    </ColumnWidget>
                    <DualListSelectorList extraClass={'dual-list-selector__list-mid_width'}>
                    {availableMerchNumActivePage === 0 && <div id='available_mid' className='dual-list-selector-pagination__mid'><span>{chain.key === "NA" ? '' : translations.merchantNumbers}</span><span className={chain.key === "NA" ? 'dual-list-selector-pagination__naMidFirstSpan' : 'dual-list-selector-pagination__midFirstSpan'}>{translations.page} {availableMerchNumActivePage + 1} {translations.of} {totalPages}</span></div>}
                    {availableMerchNumActivePage > 0 && <div id='available_mid' className='dual-list-selector-pagination__mid'><span>{chain.key === "NA" ? '' : translations.merchantNumbers}</span><span className={chain.key === "NA" ? 'dual-list-selector-pagination__naMidPrevSpan' : 'dual-list-selector-pagination__midPrevSpan'} value='available' onClick={(event) => this.previousPageMidLevel(event)}>{`<<  `}</span><span>{translations.page}  {availableMerchNumActivePage + 1} {translations.of} {totalPages}</span></div>}
                    {slicedMids && slicedMids.map((merchNum) => {
                        return (
                            <ColumnWidget
                                actions={extraActions}
                                desc={merchNum.key}
                                identifier={merchNum}
                                //isHidden={column.isHidden}
                                isReadOnly={merchNum.isRuleCreated === "false" ? false : true}
                                isSelected={false}
                                key={`${merchNum.key}_${availableMerchNumActivePage}`}
                                name={merchNum.key}
                                // toggleVisibility={this.toggleVisibility}
                                animate={false}
                                //id={`${this.props.id}_ColumnWidget`}
                                hideToolTip={false}
                                reportName={'MRE'}
                                extraClass={'column-widget__MRE'}
                            />
                        )
                    })}
                    {availableMerchNumActivePage + 1 < totalPages && <div className='dual-list-selector-pagination__mid'><span className='dual-list-selector-pagination__midNextSpan' value='available' onClick={(event) => this.nextPageMidLevel(event)}>{availableMerchNumActivePage + 1 < totalPages ? `${translations.next}  >>` : ''}</span></div>}
                    </DualListSelectorList>
                    </div>
                    )
                }
            });
            return (
                <DualListSelectorList extraClass={'dual-list-selector__list-chain_width'}>
                    {availableChainCurrentPage === 0 && <div id='available_chain' className='dual-list-selector-pagination'><span className='dual-list-selector-pagination__firstSpan'>{translations.page} {this.state.availableChainCurrentPage + 1} {translations.of} {totalPages}</span></div>}
                    {availableChainCurrentPage > 0 && <div id='available_chain' className='dual-list-selector-pagination'><span className='dual-list-selector-pagination__prevSpan' value='available' onClick={(event) => this.previousPageChainLevel(event)}>{`<< `}</span><span>{translations.page} {this.state.availableChainCurrentPage + 1} {translations.of} {totalPages}</span></div>}
                    {newAvailableMerchantNumbers}
                    {availableChainCurrentPage + 1 < totalPages && <div className='dual-list-selector-pagination'><span className='dual-list-selector-pagination__nextSpan' value='available' onClick={(event) => this.nextPageChainLevel(event)}>{availableChainCurrentPage - 1 <= totalPages ? `${translations.next} >>` : ''}</span></div>}
                </DualListSelectorList>
            );
        }
    }


    showActiveMerchantNumbers = () => {
        let newSelectedMerchantNumbers = [];
        const { activeMerchNumActivePage, selectedMerchantNumbers, overallFilter, acquirerCode, 
            activeFilter, totalActiveMerchNumPages, activeChainCurrentPage, totalChainPageSize, translations,
            totalMerchantNumbersPageSize, isViewFilter } = this.state;
        const extraClosableActions = [
            {
              callback: this.removeField,
              icon: CloseIcon,
            },
        ];
        const activeDropDownActions = [
            {
                callback: this.openActiveDropDownList,
                icon: ChevronDownIcon,
            }
        ];

        if(acquirerCode === 'GPN') {
            let totalPages = 1;
            newSelectedMerchantNumbers =selectedMerchantNumbers.map((chain) => {

                let newActiveMerchantNumbers = chain.mids;

                if(overallFilter !== '') {
                    newActiveMerchantNumbers = newActiveMerchantNumbers.filter(merchNum => merchNum.key.toLowerCase().includes(overallFilter.toLowerCase()));
                }

                if(activeFilter !== '') {
                    newActiveMerchantNumbers = newActiveMerchantNumbers.filter(merchNum => merchNum.key.toLowerCase().includes(activeFilter.toLowerCase()));
                }

                if(newActiveMerchantNumbers && newActiveMerchantNumbers.length > 0) {
                    totalPages = Math.ceil( newActiveMerchantNumbers.length / totalMerchantNumbersPageSize );
                }

                let newMerchantNumbers =  newActiveMerchantNumbers.slice(activeMerchNumActivePage*100, (activeMerchNumActivePage*100)+100);
                // sorting mids
                newMerchantNumbers = this.getSortedList(newMerchantNumbers);
                return newMerchantNumbers.map((merchNum) => {
                    return (
                        <ColumnWidget
                            actions={extraClosableActions}
                            desc={merchNum.key}
                            identifier={merchNum}
                            //isHidden={column.isHidden}
                            isReadOnly={isViewFilter ? true : false}
                            isSelected={false}
                            key={merchNum.key}
                            name={merchNum.key}
                            // toggleVisibility={this.toggleVisibility}
                            animate={false}
                            //id={`${this.props.id}_ColumnWidget`}
                            hideToolTip={false}
                            reportName={'MRE'}
                            extraClass={'column-widget__MRE'}
                        />
                    );
                });
            });
            return (
                <DualListSelectorList extraClass={'dual-list-selector__list-chain_width'}>
                    {activeMerchNumActivePage === 0 && <div id='active_chain' className='dual-list-selector-pagination'>{translations.merchantNumbers}<span className='dual-list-selector-pagination__firstMidSpan'>{translations.page} {activeMerchNumActivePage + 1} {translations.of} {totalPages}</span></div>}
                    {activeMerchNumActivePage > 0 && <div id='active_chain' className='dual-list-selector-pagination'>{translations.merchantNumbers}<span className='dual-list-selector-pagination__prevMidSpan' value='active' onClick={(event) => this.previousPageChainLevel(event)}>{`<< `}</span><span>{translations.page} {activeMerchNumActivePage + 1} {translations.of} {totalPages}</span></div>}
                    {newSelectedMerchantNumbers}
                    {activeMerchNumActivePage + 1 < totalPages && <div className='dual-list-selector-pagination'><span className='dual-list-selector-pagination__nextMidSpan' value='active' onClick={(event) => this.nextPageChainLevel(event)}>{activeMerchNumActivePage + 1 < totalPages ? `${translations.next} >>` : ''}</span></div>}
                </DualListSelectorList>
            );
        } else {
            let totalPages = 1;
            newSelectedMerchantNumbers = selectedMerchantNumbers.map((chain) => {return {...chain}});

            newSelectedMerchantNumbers = this.getOverallSearchFilteredData(newSelectedMerchantNumbers, overallFilter);
            newSelectedMerchantNumbers = this.getActiveSearchFilteredData(newSelectedMerchantNumbers, activeFilter);

            if(newSelectedMerchantNumbers && newSelectedMerchantNumbers.length > 0) {
                totalPages = Math.ceil(newSelectedMerchantNumbers.length / totalChainPageSize);
            }

            // sorting chain
            newSelectedMerchantNumbers = this.getSortedList(newSelectedMerchantNumbers);

            newSelectedMerchantNumbers = newSelectedMerchantNumbers.slice(activeChainCurrentPage*totalChainPageSize, 
                (activeChainCurrentPage*totalChainPageSize)+totalChainPageSize).map((chain) => {
                if(!chain.isExpanded) {
                    return (
                        <ColumnWidget
                            actions={extraClosableActions}
                            desc={chain.key}
                            //extraClass={column.extraClass}
                            identifier={chain}
                            //isHidden={column.isHidden}
                            isReadOnly={isViewFilter ? true : false}
                            isSelected={false}
                            key={chain.key}
                            name={chain.key === "NA" ? `${translations.merchantNumbers}` : chain.key + ` - ${translations.chain}`}
                            // toggleVisibility={this.toggleVisibility}
                            animate={false}
                            //id={`${this.props.id}_ColumnWidget`}
                            hideToolTip={false}
                            isExpanded={chain.isExpanded}
                            dropdown={chain.mids.length > 0 ? activeDropDownActions : null}
                            reportName={'MRE'}
                            extraClass={'column-widget__MRE'}
                        />
                    );
                } else {
                    let totalPages = 1;
                    if(chain.mids && chain.mids.length > 0) {
                        totalPages = Math.ceil( chain.mids.length / totalMerchantNumbersPageSize );
                    }

                    let slicedMids = chain.mids.slice(activeMerchNumActivePage * totalMerchantNumbersPageSize, 
                        (activeMerchNumActivePage * totalMerchantNumbersPageSize) + totalMerchantNumbersPageSize)
                    // sorting mids
                    slicedMids = this.getSortedList(slicedMids);
                    return (
                        <div>
                    <ColumnWidget
                        actions={extraClosableActions}
                        desc={chain.key}
                        identifier={chain}
                        //isHidden={column.isHidden}
                        isReadOnly={isViewFilter ? true : false}
                        isSelected={false}
                        key={chain.key}
                        name={chain.key === "NA" ? `${translations.merchantNumbers}` : chain.key + ` - ${translations.chain}`}
                        // toggleVisibility={this.toggleVisibility}
                        animate={false}
                        //id={`${this.props.id}_ColumnWidget`}
                        hideToolTip={false}
                        isExpanded={chain.isExpanded}
                        dropdown={activeDropDownActions}
                        reportName={'MRE'}
                        extraClass={'column-widget__MRE'}
                    />
                    <DualListSelectorList extraClass={'dual-list-selector__list-mid_width'}>
                        {activeMerchNumActivePage === 0 && <div id='active_mid' className='dual-list-selector-pagination__mid'><span>{chain.key === "NA" ? '' : translations.merchantNumbers}</span><span className={chain.key === "NA" ? 'dual-list-selector-pagination__naMidFirstSpan' : 'dual-list-selector-pagination__midFirstSpan'}>{translations.page} {activeMerchNumActivePage + 1} {translations.of} {totalPages}</span></div>}
                        {activeMerchNumActivePage > 0 && <div id='active_mid' className='dual-list-selector-pagination__mid'><span>{chain.key === "NA" ? '' : translations.merchantNumbers}</span><span className={chain.key === "NA" ? 'dual-list-selector-pagination__naMidPrevSpan' : 'dual-list-selector-pagination__midPrevSpan'} value='active' onClick={(event) => this.previousPageMidLevel(event)}>{`<< `}</span><span>{translations.page} {activeMerchNumActivePage + 1} {translations.of} {totalPages}</span></div>}
                        {slicedMids && slicedMids.map((merchNum) => {
                            return (
                                <ColumnWidget
                                    actions={extraClosableActions}
                                    desc={merchNum.key}
                                    identifier={merchNum}
                                    //isHidden={column.isHidden}
                                    isReadOnly={isViewFilter ? true : false}
                                    isSelected={false}
                                    key={merchNum.key}
                                    name={merchNum.key}
                                    // toggleVisibility={this.toggleVisibility}
                                    animate={false}
                                    //id={`${this.props.id}_ColumnWidget`}
                                    hideToolTip={false}
                                    reportName={'MRE'}
                                    extraClass={'column-widget__MRE'}
                                />
                            )
                        })}
                        {activeMerchNumActivePage + 1 < totalPages && <div className='dual-list-selector-pagination__mid'><span className='dual-list-selector-pagination__midNextSpan' value='active' onClick={(event) => this.nextPageMidLevel(event)}>{activeMerchNumActivePage + 1 < totalPages ? `${translations.next} >>` : ''}</span></div>}
                    </DualListSelectorList>
                    </div>
                    );
                }
            });
            return (
                <DualListSelectorList extraClass={'dual-list-selector__list-chain_width'}>
                    {activeChainCurrentPage === 0 && <div id='active_chain' className='dual-list-selector-pagination'><span className='dual-list-selector-pagination__firstSpan'>{translations.page} {activeChainCurrentPage + 1} {translations.of} {totalPages}</span></div>}
                    {activeChainCurrentPage > 0 && <div id='active_chain' className='dual-list-selector-pagination'><span className='dual-list-selector-pagination__prevSpan' value='active' onClick={(event) => this.previousPageChainLevel(event)}>{`<<  `}</span><span>{translations.page} {activeChainCurrentPage + 1} {translations.of} {totalPages}</span></div>}
                    {newSelectedMerchantNumbers}
                    {activeChainCurrentPage + 1 < totalPages && <div id='active_chain_next' className='dual-list-selector-pagination'><span className='dual-list-selector-pagination__nextSpan' value='active' onClick={(event) => this.nextPageChainLevel(event)}>{activeChainCurrentPage + 1 < totalPages ? `${translations.next} >>` : ''}</span></div>}
                </DualListSelectorList>
            );
        }
    }

    applyChanges = () => {
        this.props.handleDualSelectorChanges(this.props.id, this.state.selectedMerchantNumbers);
        this.handleOutsideClick(true);
    }

    cancelChanges = () => {
        if(this.props.isEditRule) {
            this.setState({
                overallFilter: '',
                availableFilter: '',
                activeFilter: '',
                availableChainCurrentPage: 0,
                activeChainCurrentPage: 0,
                availableMerchNumActivePage: 0,
                activeMerchNumActivePage: 0,
                isDropDownVisible: false,
                isCollapsed: false,
                dropDownMerchNumbers: [],
                dropDownActiveMerchNumbers: [],
                availableChainSelected: '',
                activeChainSelected: '',
                isActiveCollapsed: false,
                isViewFilter: false,
                isFilterApplied: false,
                isMreFilterPaneVisible: false,
            }, () => {
                this.updateEditFilter(this.props.selectedMerchantNumbers, this.state.finalAvailableDataAccess);
            });
        } else {
            this.setState({
                selectedMerchantNumbers: [],
                availableMerchantNumbers: this.state.finalAvailableDataAccess,
                overallFilter: '',
                availableFilter: '',
                activeFilter: '',
                availableChainCurrentPage: 0,
                activeChainCurrentPage: 0,
                availableMerchNumActivePage: 0,
                activeMerchNumActivePage: 0,
                isDropDownVisible: false,
                isCollapsed: false,
                dropDownMerchNumbers: [],
                dropDownActiveMerchNumbers: [],
                availableChainSelected: '',
                activeChainSelected: '',
                isActiveCollapsed: false,
                isViewFilter: false,
                isFilterApplied: false,
                isMreFilterPaneVisible: false,
            });
        }
    }

    showSelectedCount = (dataList) => {
        let selectMidsCount = 0;
        if(dataList.length > 0) {
            dataList.forEach((chain) => {
                if(chain.mids.length > 0) {
                    selectMidsCount += chain.mids.length;
                } else {
                    selectMidsCount += 1;
                }
            });
        }

        return selectMidsCount;
    }

    render() {

        const {
            availableFilter,
            activeFilter,
            overallFilter,
            translations,
            acquirerCode,
            isViewFilter,
            reportName,
            isMreFilterPaneVisible,
            isDropDownVisible,
            selectedMerchantNumbers,
            label,
            whiteLabelingFlag,
          } = this.state;

        const wrapperClass = classnames('dual-list-selector');
        let selectMidsCount = this.showSelectedCount(selectedMerchantNumbers);

        return (
          <div className='reason-code-wrapper'>
            <TextField
                htmlFor={label}
                labelContent={label}
                isRequired={true}
                filterErrorMsg={this.props.filterErrorMsg}
                reportName={reportName}
                acqCode={acquirerCode}
                isAllMerchantSelected={this.props.isAllMerchantSelected}
                allMerchantSelectedMsg={this.props.allMerchantSelectedMsg}
            >
                <OutsideClickHandler
                    onClickOutside={() => this.handleOutsideClick(false)}
                >
                <div className='mre-code-view-autocomplete'>
                <div role='button' className="reason-code-srch-mngr" onClick={this.onClick} style={{ border: this.props.filterErrorMsg && this.state.reportName == 'MRE' ?"1px solid red" : ''}}>
                <div className="mre-srch-icon"> <SearchIcon /> </div>
                        <Search
                            filterText={overallFilter}
                            onChange={this.setOverallSearchFilter}
                            placeholder={selectMidsCount > 0 ? `${selectMidsCount} value(s) selected` : `${translations.search}`}
                            filtername={'mre_merchant_numbers'}
                            style={{ width: "200px" }}
                            isMreFilterPaneVisible={isMreFilterPaneVisible}
                            reportName={reportName}
                            extraClass={acquirerCode}
                        />
                </div>
                {isDropDownVisible && <div className='dual-list-overlay'>
                    <div className={wrapperClass + ' dual-list-selector__width'}>
                    {!isViewFilter && <DualListSelectorPanel extraClass={'dual-list-selector__panel-width'}>
                        <DualListSelectorHeading
                        title={acquirerCode === 'HPY' ? `${translations.searchLabel}` : `${translations.available} ${translations.merchantNumbers}`}
                        reportName={reportName}
                        />
                    <Search
                        id={`${this.props.id}_columnManager_textbox_Search_Available_Columns`}
                        filterText={availableFilter}
                        onChange={this.setAvailableSearchFilter}
                        placeholder={`${translations.search}`}
                        extraClass={acquirerCode + ' search__mre'}
                        isMreFilterPaneVisible={isMreFilterPaneVisible}
                        reportName={reportName}
                    />
                    <DualListSelectorActionBar extraClass='dual-list-selector__action-bar-mre'>
                        <LinkInlineButton
                            id={`${this.props.id}_columnManager_btn_Add_All`}
                            action={this.addAllData}
                            // disabled={this.disableAddAllAction}
                        >
                            {translations.addAll}
                        </LinkInlineButton>
                    </DualListSelectorActionBar>
                    <div>
                        {this.showAvailableMerchantNumbers()}
                    </div>
                </DualListSelectorPanel>}
                <DualListSelectorPanel extraClass={!isViewFilter ? 'dual-list-selector__panel-width' : 'dual-list-selector__panel-viewWidth'}>
                    <DualListSelectorHeading
                      title={acquirerCode === "HPY" ? `${translations.searchLabelActive}` : `${translations.active} ${translations.merchantNumbers}`}
                      reportName={reportName}
                    />
                    <Search
                        id={`${this.props.id}_columnManager_textbox_Search_Active_Columns`}
                        filterText={activeFilter}
                        onChange={this.setActiveSearchFilter}
                        placeholder={`${translations.search}`}
                        extraClass={acquirerCode + ' search__mre'}
                        isMreFilterPaneVisible={isMreFilterPaneVisible}
                        reportName={reportName}
                    />
                    {!isViewFilter && <DualListSelectorActionBar extraClass='dual-list-selector__action-bar-mre'>
                        <LinkInlineButton 
                            id={`${this.props.id}_columnManager_btn_Add_All`}
                            action={this.removeAllData}
                            // disabled={this.disableRemoveAllAction}
                        >
                            {translations.removeAll}
                        </LinkInlineButton>
                    </DualListSelectorActionBar>}
                    <div>
                        {this.showActiveMerchantNumbers()}
                    </div>
                </DualListSelectorPanel>
            {!isViewFilter && <OptionBoxPopupFooter
                // applyDisabled={this.props.applyDisabled}
                applyText={`${translations.apply}`}
                cancelText={`${translations.cancel}`}
                id={this.props.id}
                onApply={this.applyChanges}
                onCancel={this.cancelChanges}
                extraClass={this.state.acquirerCode + ' option-box-content-footer__mre'}
                whiteLabelingFlag={whiteLabelingFlag && this.state.acquirerCode=="HPY"}
            />}
            </div>
            </div>}
            </div>
            </OutsideClickHandler>
            </TextField>
        </div>)
    }
};

export default DualMerchantDataListSelector;